import { SlugNameService } from "./../../Services/slug-name.service";
import {
    AfterViewChecked,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
} from "@angular/core";
import { Router } from "@angular/router";

import { AccountSettingService } from "src/app/Services/account-setting.service";
import Swal from "sweetalert2";

import { TranslateService } from "@ngx-translate/core";

import { CheckoutService } from "../../Services/checkout.service";
import { EmbryoService } from "../../Services/Embryo.service";
import { LoginUsersService } from "../../Services/login-users.service";
import { ReactivityService } from "../../Services/reactivity.service";
import { MetaService } from "src/app/Services/meta-data.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import { MarketingService } from "src/app/Services/marketing.service";
import { HomePageService } from "src/app/Services/home-page.service";
import { Subscription } from "rxjs";

@Component({
    selector: "embryo-Cart",
    templateUrl: "./Cart.component.html",
    styleUrls: ["./Cart.component.scss"],
})
export class CartComponent implements OnInit, AfterViewChecked, OnDestroy ,AfterViewInit {
    products: any;
    popupResponse: any;
    productList: any;
    suggestions: any;
    lang: any;
    quantityInput = 1;
    loading: boolean = false;
    disabled_button_checkout: boolean = false;
    authUser: any;
    disabledCheckout: boolean = false;
    disabledCheckoutBtn: boolean = false;
    user: any;
    isGuest: boolean = false;
    totalCommission: any;
    environmentVariables: any;
    gifts: any;
    homeSubscription: any;
    cartSubscription = new Subscription();
    initData: any;
    flattenedProductList :any =[]
    productlistcopyed:any
    cashBack: any;
    constructor(
        public embryoService: EmbryoService,
        private router: Router,
        private translate: TranslateService,
        private checkoutService: CheckoutService,
        private cdRef: ChangeDetectorRef,
        public userLoginServies: LoginUsersService,
        private reactivityService: ReactivityService,
        private account: AccountSettingService,
        private metaService: MetaService,
        private confgServ: StaticPagesService,
        private marketingService: MarketingService,
        private homeService: HomePageService,
        private slugNameService: SlugNameService
    ) {
        this.productList = [];
        this.suggestions = [];

        this.authUser = JSON.parse(
            <string>localStorage.getItem("auth_user_crocs")
        );
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
        embryoService.emitLang.subscribe((lang: string) => {
            this.lang = lang;
            translate.setDefaultLang(lang);
            if (this.lang == "en")
                this.metaService.setTitle(
                    `Cart - ${this.environmentVariables?.APP_NAME}`
                );
            else
                this.metaService.setTitle(
                    `عربه التسوق - ${this.environmentVariables?.APP_NAME_AR}`
                );
        });
        this.embryoService.productCartSub.subscribe((res) => {
            if (res) {
                this.productList = res;
                this.validateCartItems(this.productList)
                const itemscantbuy = res.filter(
                    (item: any) =>
                        (item.can_buy != null && item.amount > item.can_buy) ||
                        item.soft_deleted ||
                        item.active == 0
                );
                itemscantbuy.length
                    ? (this.disabledCheckout = true)
                    : (this.disabledCheckout = false);
            }
        });

        this.embryoService.productSuggestions.subscribe((res) => {
            if (res) {
                this.suggestions = res;
            }
        });
        this.embryoService.productGifts.subscribe((res) => {
            if (res) {
                this.gifts = res;
            }
        });
    }
  ngAfterViewInit(): void {
     let  profile = JSON.parse(localStorage.getItem('auth_user_crocs')!);
      let vistorId = localStorage.getItem('vistorId');
        // let _items;
      setTimeout(() => {
          let    _items = this.productList.map((product:any) => {
              return {
                id: product.id,
                quantity: product.amount,
                price:product.price
              };
            });
  this.marketingService.initCriteoq(profile, vistorId, 'viewBasket', _items);

      }, 1000);
  
  }

    ngOnInit() {
        this.homeSubscription = this.homeService.isInitLoading.subscribe(
            (value) => {
                if (value) {
                    this.loading = true;
                } else {
                    this.loading = false;
                }
            }
        );
        this.lang = localStorage.getItem("lang");
        this.translate.setDefaultLang(this.lang);
        this.embryoService.productCartSub.subscribe((res) => {
            if (res) {
                const itemscantbuy = res.filter(
                    (item: any) =>
                        (item.can_buy != null && item.amount > item.can_buy) ||
                        item.soft_deleted ||
                        item.active == 0
                );
                itemscantbuy.length
                    ? (this.disabledCheckout = true)
                    : (this.disabledCheckout = false);
            }
        });
        this.getCart();
        this.getUser();
        this.isGuest = this.userLoginServies.isGuest();
    }

    validateCartItems(items: any) {
      if (this.environmentVariables.can_checkout) {
                 this.flattenedProductList =[]
           if(this.environmentVariables.SPLIT_CART_BY_VENDOR){
              items.forEach((subArray: any) => {
                if (subArray && subArray.items) {
                  this.flattenedProductList.push(...subArray.items);
                }
              });
             this.productlistcopyed  = [...new Set(this.flattenedProductList)];   
        }
        else{
           this.productlistcopyed = this.productList;
        }
      }
      if(this.productlistcopyed){
        let isDisabled = false; 
        for (let index = 0; index < this.productlistcopyed?.length; index++) {
          if(this.productlistcopyed[index].amount < this.productlistcopyed[index].min_per_order){
            isDisabled  = true;
          }
        }
       this.disabledCheckoutBtn = isDisabled; 
      }
      
}


    getInitailze() {
        this.homeService.getInitData().subscribe((res) => {
            if (res?.localization) {
                if (!this.initData) {
                    this.initData = res;
                    this.getCart();
                }
            }
        });
    }
    getCart() {
        if (this.initData || this.productList) {
            this.loading = true;
            this.cartSubscription = this.checkoutService.getCart().subscribe({
                next: (rep) => {
                    if (rep.code === 200 && rep.data && rep.data.items) {
                        this.productList = rep.data.items;
                        this.cashBack = rep.data.cashback;

                        if (
                            this.environmentVariables
                                ?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER
                        ) {
                            this.environmentVariables.can_checkout =
                                rep.data?.can_checkout;
                        }

                        this.embryoService.productCartSub.next(
                            this.productList
                        );
                        this.suggestions = rep.data.suggestions;

                        this.gifts = rep.data.gifts;
                        this.loading = false;
                        this.cdRef.detectChanges();
                    } else {
                        this.loading = false;
                    }
                },
            });
            this.calculateTotalCommission();
            this.isGuest = this.userLoginServies.isGuest();
        } else {
            this.getInitailze();
        }
    }

    ValidateCartStock(data?: any) {
        let count = 0;
        this.productList = data;
        if (this.productList?.length) {
            this.productList.forEach((item: any) => {
                if (item.amount > item.stock) {
                    count += 1;
                }
                if (count != 0) {
                    this.disabled_button_checkout = true;
                } else {
                    this.disabled_button_checkout = false;
                }
            });
        }
    }

    ngAfterViewChecked(): void {
        this.cdRef.detectChanges();
    }

    getUser() {
        if (this.userLoginServies.getUser()) {
            this.user = this.userLoginServies.getUser();
        }
    }

    public removeProduct(product: any, index: number) {
        product["loading"] = true;
        const cartProduct = {
            reset: false,
            items: [{ id: product.id, amount: 0 }],
        };
        this.checkoutService.addOrUpdateToCart(cartProduct).subscribe(
            (rep: any) => {
                if (rep.code === 200) {
                    Swal.fire({
                        html: `<p style='color:white'>${
                            this.lang === "en"
                                ? "Product removed from cart"
                                : "تم ازالة المنتج السلة"
                        }</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                    product["loading"] = false;
                    this.productList = rep.data.items;
                    this.cashBack = rep.data.cashback;
                    this.embryoService.productCartSub.next(this.productList);
                    this.suggestions = rep.data.suggestions;
                }
            },
            (err) => (this.loading = false)
        );
    }

    public getPopupResponse(response: any, value: any) {
        if (response) {
            this.embryoService.removeLocalCartProduct(value);
        }
    }

    public calculateProductSinglePrice(product: any, value: any) {
        let price = 0;
        product.quantity = value;
        if (product.discount_price !== null) {
            price += product.discount_price;
        } else {
            price += product.price;
        }
        return price;
    }

    public calculateTotalPrice() {
        let subtotal = 0;
        if (this.productList && this.productList?.length > 0) {
            for (const product of this.productList) {
                if (product.discount_price !== null) {
                    subtotal += product.discount_price;
                } else {
                    subtotal += product.price;
                }
            }
            return subtotal;
        }
        return subtotal;
    }

    cartEmit(data: any) {
        if (data) {
            this.getCart();
        }
    }

 
    public getTotalPrice() {
      this.flattenedProductList =[]
           if(this.environmentVariables.SPLIT_CART_BY_VENDOR){
              this.productList.forEach((subArray: any) => {
                if (subArray && subArray.items) {
                  this.flattenedProductList.push(...subArray.items);
                }
              });
             this.productlistcopyed  = [...new Set(this.flattenedProductList)];   
        }
        else{
           this.productlistcopyed = this.productList;
        }
        let total = 0;
        if (this.productlistcopyed && this.productlistcopyed?.length > 0) {
            for (const product of this.productlistcopyed) {
                product.discount_price !== null
                    ? (total += product.discount_price)
                    : (total += product.price);
            }
            return total;
        }

        return total;
    }

    public updateLocalCartProduct() {
      if(this.environmentVariables.ENABLE_MULTI_VENDOR && this.productList.filter((x:any)=>x.items).some((a:any)=>a.has_error)){
         Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang === "en"
                            ? "Some of your vendors have not reached the minimum purchase requirement"
                            : "لديك بعض البائعين لم تصل الي الحد الادني للشراء منهم"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });

                return
      }

        this.environmentVariables.cart_total = this.getTotalPrice();
        this.environmentVariables.can_checkout =
            this.environmentVariables?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER <
                this.environmentVariables?.cart_total ||
            this.environmentVariables
                ?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER ==
                this.environmentVariables?.cart_total ||
            !this.environmentVariables?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER
                ? true
                : false;
        this.confgServ.setenvConfigOfflineApp(this.environmentVariables);
        if (this.environmentVariables.can_checkout) {
                 this.flattenedProductList =[]
           if(this.environmentVariables.SPLIT_CART_BY_VENDOR){
              this.productList.forEach((subArray: any) => {
                if (subArray && subArray.items) {
                  this.flattenedProductList.push(...subArray.items);
                }
              });
             this.productlistcopyed  = [...new Set(this.flattenedProductList)];   
        }
        else{
           this.productlistcopyed = this.productList;
        }
            const items = this.productlistcopyed.filter(
                (item: any) =>
                    item.in_stock == false ||
                    item.active == false ||
                    item.available_soon == true
            );
            const itemscantbuy = this.productlistcopyed.filter(
                (item: any) =>
                    item.can_buy != null && item.amount > item.can_buy
            );
            if (items?.length) {
                Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang === "en"
                            ? "You have items not available any more, remove them so you can proceed"
                            : "يوجد منتجات غير متاحة , احذفهم حتي يمكنك الاستمرار"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
                return false;
            }
            if (itemscantbuy?.length) {
                Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang === "en"
                            ? "You have exceeded the max number of one of  your orders, remove them so you can proceed"
                            : "لقد تخطيت الحد الأقصى لأحد المنتجات , احذفهم حتي يمكنك الاستمرار "
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
                return false;
            }

            if (
                this.isGuest &&
                !(
                    this.environmentVariables?.enable_affiliate ||
                    this.environmentVariables?.enable_guest_checkout
                )
            ) {
                this.router.navigate(["/" + this.lang + "/session/signin"], {
                    queryParams: {
                        returnUrl: "/" + this.lang + "/checkout",
                    },
                });
                this.marketingService.checkoutEvents(
                    "checkout",
                    this.productList,
                    2,
                    "Collect Payment Info"
                );
            } else {
                this.router.navigate(["/" + this.lang + "/checkout"]);
                this.marketingService.checkoutEvents(
                    "checkout",
                    this.productList,
                    2,
                    "Collect Payment Info"
                );
            }
        } else {
            Swal.fire({
                html: `<p style='color:white'>${
                    this.lang === "en"
                        ? "Add " +
                          (this.environmentVariables
                              ?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER - this.environmentVariables.cart_total ).toFixed(2) + " " +this.environmentVariables.CURRENCY_CODE_EN +  " to place your order"
                        : "أضف منتجات بقيمة " +
                         (this.environmentVariables
                              ?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER - this.environmentVariables.cart_total).toFixed(2) +" "+this.environmentVariables.CURRENCY_CODE_AR + " لأستكمال طلبك" 
                }</p>`,
                width: 250,
                position: "bottom-end",
                background: "#bd362f",
                timerProgressBar: true,
                showConfirmButton: false,
                timer: 3000,
                backdrop: false,
                allowOutsideClick: true,
            });
        }

        return;
    }

    public getQuantityValue(product: any) {
        if (product.quantity) {
            return product.quantity;
        } else {
            return 1;
        }
    }

    getProductName(product: any) {
        return this.slugNameService.getProductName(product);
    }
    moveToFav(product: any, index: number) {
        const cartProduct = {
            reset: false,
            items: [{ id: product.id, amount: 0 }],
        };
        this.checkoutService
            .addOrUpdateToCart(cartProduct)
            .subscribe((rep: any) => {
                if (rep.code === 200) {
                    Swal.fire({
                        html: `<p style='color:white'>${
                            this.lang === "en"
                                ? "Product moved to favourite"
                                : "تم نقل المنتج الي المفضلة"
                        }</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#51A351",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                    this.embryoService.productCartSub.next(rep.data.items);
                    this.reactivityService.setDataToStore(
                        "currentFavProduct",
                        product
                    );
                }
            });
    }

    calculateTotalCommission() {
        if(this.productList.length > 0){
            let totalCommission = this.productList?.map((res: any) =>
                res.commission_amount
            );
            let reducer = (accumulator: any, currentValue: any) =>
                accumulator + currentValue;
            this.totalCommission = totalCommission.reduce(reducer, 0);
            return this.totalCommission;
        }
    }

    addProductToCart(product: any) {
        let foundIndex = this.productList.findIndex(
            (filterProduct: any) => product.id === filterProduct.id
        );
        if (foundIndex != -1) {
            product.amount = this.productList[foundIndex].amount;
        }
        if (product.can_buy == null || product.can_buy > 0) {
            product.amount++;
            this.AddOrUpdateCart(product, "add");
        }
    }

    public AddOrUpdateCart(product: any, type: string | null) {
        product.loading = true;
        if (product.in_stock) {
            const cartProduct = {
                reset: false,
                items: [{ id: product.id, amount: product.amount }],
            };
            this.callApiAddProductToCart(product, cartProduct, type);
        } else if (product.preorder) {
            const cartProduct = {
                reset: false,
                items: [{ id: product.id, amount: product.amount }],
            };
            this.callApiAddProductToCart(product, cartProduct, type);
        } else if (product.available_soon) {
            Swal.fire({
                html: `<p style='color:white'>${
                    this.lang === "en"
                        ? "Ops This product is available soon"
                        : "للاسف هذا سيتوفر قريبا "
                }</p>`,
                width: 250,
                position: "bottom-end",
                background: "#bd362f",
                timerProgressBar: true,
                showConfirmButton: false,
                timer: 3000,
                backdrop: false,
                allowOutsideClick: true,
            });
        } else {
            Swal.fire({
                html: `<p style='color:white'>${
                    this.lang === "en"
                        ? "Ops This product is out of stock"
                        : "للاسف نفد هذا المنتج من المخازن "
                }</p>`,
                width: 250,
                position: "bottom-end",
                background: "#bd362f",
                timerProgressBar: true,
                showConfirmButton: false,
                timer: 3000,
                backdrop: false,
                allowOutsideClick: true,
            });
        }
    }

    callApiAddProductToCart(product: any, cartProduct: any, type: any) {
        this.loading = true;
        this.checkoutService.addOrUpdateToCart(cartProduct).subscribe(
            (rep: any) => {
                setTimeout(() => {
                    product.loading = false;
                }, 200);
                if (rep.code === 200) {
                    this.marketingService.fbTracking("track", "AddToCart", {
                        content_ids: [product.sku],
                        content_type: "product",
                        content_name: product.name,
                        value: product.discount_price
                            ? product.discount_price
                            : product.price,
                        contents: [
                            { id: product.sku, quantity: product.amount },
                        ],
                        currency:  this.environmentVariables?.CURRENCY_CODE_EN,
                    });
                  this.marketingService.snapTracking("track", 'ADD_CART', {
                        item_ids: [product.sku],
                        number_items: product.amount,
                        price: product.discount_price
                            ? product.discount_price
                            : product.price,
                        currency: this.environmentVariables?.CURRENCY_CODE_EN,
                    });

               
                    if (this.environmentVariables?.GOOGLE_CONVERSION_ID) {


                          this.marketingService.googleConversionTracking(
                          "conversion",
                          this.environmentVariables?.GOOGLE_CONVERSION_ID,
                          this.environmentVariables?.GOOGLE_CONVERSION_LABEL_ADD_TO_CART,
                          this.environmentVariables?.GOOGLE_CONVERSION_TRANSACTION_ID
                        );
                      }
                      
                    this.suggestions = rep.data.suggestions;
                    this.suggestions = rep.data.suggestions;
                    this.gifts = rep.data.gifts;
                    this.loading = false;
                    type === "add" ? this.addMsg() : this.removeMsg();
                    this.productList = rep.data.items;
                    this.cashBack = rep.data.cashback;
                    this.embryoService.productCartSub.next(rep.data.items);
                    localStorage.setItem(
                        "giftItems",
                        JSON.stringify(rep.data.gifts)
                    );
                    localStorage.setItem(
                        "suggestionsItems",
                        JSON.stringify(rep.data.suggestions)
                    );
                }
                let obj = {
                    item_name: product.name,
                    item_id: product.id,
                    active: product.active,
                    price: product.discount_price
                        ? product.discount_price
                        : product.price,
                    item_brand:
                        product.details && product.details.brand
                            ? product.details.brand.name
                            : "",
                    item_category: product.category
                        ? product.category.name
                        : "-",
                    item_category2: product.category
                        ? product.category.sub_categories
                            ? product.category.sub_categories[0].name
                            : "-"
                        : "-",
                    item_list_name: product.actegory ? product.actegory.id : "",
                    item_list_id: product.actegory ? product.actegory.name : "",
                    index: "",
                    quantity: product.amount,
                };
                let result = {
                    event:
                        product.amount > 0 ? "add_to_cart" : "remove_from_cart",
                    ecommerce: {
                        currency:  this.environmentVariables?.CURRENCY_CODE_EN,
                        value: product.discount_price
                            ? product.discount_price
                            : product.price,
                        items: obj,
                        extras: this.account.googleAnalaticsUserData,
                    },
                };
            },
            () =>
                setTimeout(() => {
                    product.loading = false;
                }, 200)
        );
    }

    addMsg() {
        const toastOption = {
            title: "Cart",
            msg: "",
        };
        if (this.lang === "en") {
            toastOption.title = "Cart";
            toastOption.msg = "Product added to cart successfully";
        } else {
            toastOption.title = "العربة";
            toastOption.msg = "تم إضافة المنتج الي العربة بنجاح";
        }

        Swal.fire({
            html: `<p style='color:white'>${toastOption.msg}</p>`,
            width: 250,
            position: "bottom-end",
            background: "#51A351",
            timerProgressBar: true,
            showConfirmButton: false,
            timer: 3000,
            backdrop: false,
            allowOutsideClick: true,
        });
    }

    removeMsg() {
        const toastOption = {
            title: "Cart",
            msg: "",
        };
        if (this.lang === "en") {
            toastOption.title = "Cart";
            toastOption.msg = "Product removed from cart successfully";
        } else {
            toastOption.title = "العربة";
            toastOption.msg = "تم إزالة المنتج من العربة بنجاح";
        }

        Swal.fire({
            html: `<p style='color:white'>${toastOption.msg}</p>`,
            width: 250,
            position: "bottom-end",
            background: "#51A351",
            timerProgressBar: true,
            showConfirmButton: false,
            timer: 3000,
            backdrop: false,
            allowOutsideClick: true,
        });
    }

    getVendorItemsPrice(items:any) {
      let totalPrice = 0;
      if(items){
      for (const product of items) {
           if (product.discount_price !== null) {
               totalPrice += product.discount_price;
           } else {
               totalPrice += product.price;
           }
         }
          return totalPrice;
        }
    }

    ngOnDestroy() {
        this.homeSubscription?.unsubscribe();
        this.cartSubscription?.unsubscribe();
    }


calculateProgress(product: any): number {
  return (product.amount / product.min_per_order) * 100;
}
}
